import i18n from "@/i18n";
export default [
  {
    path: i18n.t('credits.path')+i18n.t('credits.creditsGranted.path'),
    name: 'creditsGranted',
    meta: { authRequired: true },
    component: () => import('./CreditsGranted.vue')
  },
  {
    path: i18n.t('credits.path')+i18n.t('credits.creditsConsumed.path'),
    name: 'creditsConsumed',
    meta: { authRequired: true },
    component: () => import('./CreditsConsumed.vue')
  }
];